import Swiper, { Navigation, Pagination, SwiperOptions } from 'swiper';
import { createRipple } from '../button.ripple';

export class Carousel {
  public swiper!: Swiper;
  protected el!: HTMLElement;

  constructor(el: HTMLElement, config: SwiperOptions = {}) {
    this.el = el;
    this.buildSwiper(el, config);
  }

  public buildSwiper(context: HTMLElement, config: SwiperOptions) {
    const swiperEl = context.querySelector('.swiper') as HTMLElement;

    const prevEl = context.querySelector(
      '.btn-carousel.btn-prev'
    ) as HTMLElement;

    const nextEl = context.querySelector(
      '.btn-carousel.btn-next'
    ) as HTMLElement;

    [prevEl, nextEl].forEach((elm) => {
      elm && elm.addEventListener('click', createRipple);
    });

    const defaultOptions: SwiperOptions = {
      modules: [Navigation, Pagination],
      centeredSlides: false,
      grabCursor: false,
      loop: true,
      slidesPerView: 1,
      speed: 1000,
    };
    const navigation = { nextEl, prevEl };
    const pagination = { el: 'swiper-pagination' };

    this.swiper = new Swiper(swiperEl, {
      ...defaultOptions,
      navigation,
      pagination,
      ...config,
    });
  }

  
  public get activeSlide(): Element {
    const activeIndex = this.swiper.activeIndex;
    return this.swiper.slides[activeIndex];
  }
}
